<h3>Employees <span class="highlight">(Click on a employee to edit)</span></h3>
<a routerLink="/addemployee" routerLinkActive="active" class="btn btn-default">Add Employee</a>
<hr>
<div class="container divtable">
    <div class="divtablebody">
        <div class="divrow">

            <div class="coltitle   appcol codecol-emp " >Code</div>
            
            <div class="coltitle  appcol fnamecol-emp ">First Name</div>
            
            <div class="coltitle appcol lnamecol-emp ">Last Name</div>
            
            <div class="coltitle   appcol uploadedcol-emp">Uploaded</div>

            <div class="coltitle   appcol btncol-emp">&nbsp;</div>

        </div>
        
         @for (employee of employees; track employee.employeecode) {
        <div class="divrow" (click)="onEdit(employee)">

            <div class="appcol  codecol-emp appcell">{{employee.employeecode}}</div>
                    
            <div class="appcol  fnamecol-emp appcell">{{employee.fname}}</div>
                    
            <div class="appcol  lnamecol-emp appcell">{{employee.lname}}</div>
                    
            <div class="appcol  uploadedcol-emp appcell">{{employee.uploaded == '0000-00-00' ? 'Pending' : (employee.uploaded | date: 'MM/dd/yyyy') }}</div>

            <div class="appcol  btncol-emp appcell">
                      <button class="delete btn-xs btn-danger" (click)="deleteEmployee(employee); $event.stopPropagation()">Delete</button>    
            </div>
        </div>
    }
      </div>
    </div>
